import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PlatformProfile} from "../../../../model/platformprofile";
import {User} from "../../../../model/user";
import {RotationOrder} from "../../../../model/rotationOrder";
import {SavedProperty} from "../../../../model/savedProperty";
import {Product} from "../../../../model/product";
import {ProductService} from "../../../../service/product.service";
import {RotationOrderService} from "../../../../service/rotation-order.service";
import {ConfirmationDialogComponent} from "../../../dialogs/confirmation-dialog/confirmation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {TwoDigitNumberPipe} from "../../../../pipes/two-digit-number.pipe";
import NameFinderUtils from "../../../../utils/name-finder-utils";
import {LoginIdService} from "../../../../service/login-id.service";
import {startWith} from "rxjs/operators";
import {Subscription} from "rxjs";
import {PlatformService} from "../../../../service/platform.service";
import StaticData from "../../../../utils/static-data";
import {RotationOrderProductDate} from "../../../../model/rotationOrderProductDate";

@Component({
    selector: 'app-rotation-order-management',
    templateUrl: './rotation-order-management.component.html',
    styleUrls: ['./rotation-order-management.component.css']
})
export class RotationOrderManagementComponent implements OnInit, OnChanges {

    @Input() platformProfile: PlatformProfile;
    products: Product[] = new Array<Product>()
    selectedSavedPropertyForModal: SavedProperty;
    selectedMandateId: string = "init";
    showRotationOrderModal: boolean = false;
    multipleSelectionModal: boolean = false;
    showEditUserForRotationOrderModal: boolean = false;
    months: Array<string> = [];
    days: Array<string> = [];
    zipsInBerlin: Array<string> = [];
    selectedSavedProperties: Array<SavedProperty> = [];

    monthPicker = "";
    dayPicker = "";
    documentPicker = ""
    userPicker = "";

    user: User;
    usersForPlatform: User[] = [];
    editRotationOrder: RotationOrder | undefined;
    companyLoginSubscription: Subscription;

    //Determines if the error when wanting to update a user of a rotation order but no user was selected should be shown
    showUpdateUserError: boolean = false;
    //Determines if the error when wanting to add a product to a rotation order for a different user than the rotation order is already createad for should be shown
    showDifferentRotationOrderUserError: boolean = false;
    //Determines if an information should be shown when adding rotation orders for multiple saved properties when different users are used
    showMultiSelectionRotationOrderUserInformation: boolean = false;
    errorRotationOrderIndex: number | undefined;
    updatingRotationOrderUser: boolean = false;

    rotationOrders: Array<RotationOrder> = new Array<RotationOrder>();
    originalRotationOrdersCopy: Array<RotationOrder> = new Array<RotationOrder>();
    rotationOrdersToRemove: Array<RotationOrder> = new Array<RotationOrder>();
    getProductLongName = NameFinderUtils.getProductLongName;


    constructor(private productService: ProductService, private rotationOrderService: RotationOrderService,
                public dialog: MatDialog, private twoDigitNumberPipe: TwoDigitNumberPipe, private loginIdService: LoginIdService, private platformService: PlatformService) {
    }

    async ngOnInit(): Promise<void> {
        await this.loginIdService.loginServiceInitialized$.toPromise();

        this.months = StaticData.getMonthsOfYear();
        this.zipsInBerlin = StaticData.getBerlinZips();

        this.companyLoginSubscription = this.loginIdService.loginIdChanged$.pipe(startWith(true)).subscribe(() => {
            this.user = JSON.parse(sessionStorage.getItem("currentMultiUser"));
        })

        this.productService.getProducts().subscribe(products => {
            this.products = products
        })
        this.setMonthLenght(31);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes["platformProfile"]){
            this.rotationOrderService.getRotationOrdersForPlatformId(this.platformProfile.id, this.loginIdService.getCurrentHeaders()).subscribe(rotationOrders => {
                this.rotationOrders = rotationOrders;
            })
            this.platformService.getUsersByPlatformId(this.platformProfile.id, this.loginIdService.getCurrentHeaders()).subscribe(platformUsers => {
                this.usersForPlatform = platformUsers
            })
        }

    }

    /**
     * Open the modal for editing the user for a rotation order
     *
     * @param rotationOrder Rotation order which should be edited
     */
    public openEditUserForRotationOrderModal(rotationOrder: RotationOrder): void{
        this.showEditUserForRotationOrderModal = true;
        this.editRotationOrder = rotationOrder;
        this.userPicker = "";
    }

    /**
     * Closes the modal for editing the user for a rotation order.
     * Resets the values that where used in the modal.
     */
    public closeEditUserForRotationOrderModal(): void{
        this.showEditUserForRotationOrderModal = false;
        this.showDifferentRotationOrderUserError = false;
        this.showUpdateUserError = false;
        this.userPicker = this.user.id;
        this.editRotationOrder = undefined;
    }

    /**
     * Opens the rotation order modal for adding new rotation orders.
     * Creates a copy of current this.rotation orders for easy rollback if creation is canceled
     *
     * @param savedProperty SavedProperty for which the rotation orders should be edited if a single SavedProperty is being edited.
     * Undefined if multiple saved properties should be edited
     */
    public openRotationOrderModal(savedProperty: SavedProperty | undefined): void {
        this.showRotationOrderModal = true;
        this.userPicker = this.user.id;
        //Use json to create a deep copy with nested objects
        this.originalRotationOrdersCopy = JSON.parse(JSON.stringify(this.rotationOrders))
        if (savedProperty) {
            this.selectedSavedPropertyForModal = savedProperty;
        } else {
            this.multipleSelectionModal = true;
            this.rotationOrders = [];
        }
    }

    /**
     * Closes the rotation order modal for adding new rotation orders.
     * Resets all dropdown selections, the copy of original rotation orders, and updates the current rotation orders.
     */
    public closeRotationOrderModal(): void {
        this.showRotationOrderModal = false;
        this.monthPicker = "";
        this.dayPicker = "";
        this.documentPicker = "";
        this.selectedSavedPropertyForModal = undefined;
        this.rotationOrdersToRemove = [];
        this.removeRotationOrdersWithoutId();
        this.multipleSelectionModal = false;
        //Use json to create a deep copy with nested objects
        this.rotationOrders = JSON.parse(JSON.stringify(this.originalRotationOrdersCopy))
        this.originalRotationOrdersCopy = [];
    }

    /**
     * Set the number of day in the day dropdown to a specific number
     *
     * @param lenght number of days that should be set.
     */
    setMonthLenght(lenght: number) {
        this.days = [];
        for (let i = 1; i <= lenght; i++) {
            this.days.push(i.toString());
        }
    }

    /**
     * Set the number of days in the day dropdown based on a month
     *
     * @param month Month for which the days should be set
     */
    updateNumberOfDays(month: string) {
        if (month == "Februar") {
            this.setMonthLenght(28);
        } else if (month == "April" || month == "Juni" || month == "September" || month == "November") {
            this.setMonthLenght(30);
        } else {
            this.setMonthLenght(31);
        }
    }

    /**
     * Adding a rotation order to this.rotationOrders as collection for saving them later.
     * Handles rotation orders for a single saved property and multiple saved properties
     */
    public addRotationOrder(): void {
        this.showDifferentRotationOrderUserError = false;
        this.errorRotationOrderIndex = undefined;
        let product: Product | null = this.getProductByShortname(this.documentPicker);

        if (!product) {
            return
        }

        const dayIndex = this.days.indexOf(this.dayPicker.valueOf()) + 1;
        const monthIndex = this.months.indexOf(this.monthPicker.valueOf()) + 1;

        const savedProperties = this.multipleSelectionModal ? this.selectedSavedProperties : [this.selectedSavedPropertyForModal]

        savedProperties.forEach(savedProperty => {
            const existingRotationOrderForDate = this.rotationOrders.find((rotationOrder) =>
                    rotationOrder.day === dayIndex && rotationOrder.month === monthIndex && rotationOrder.savedProperty.id === savedProperty.id);

            if (existingRotationOrderForDate) {
                if(existingRotationOrderForDate.userId !== this.userPicker){
                    this.showDifferentRotationOrderUserError = true;
                    this.errorRotationOrderIndex = this.rotationOrders.indexOf(existingRotationOrderForDate);
                }
                else{
                    existingRotationOrderForDate.products.push(product);
                    this.documentPicker = "";
                }
            } else {
                const rotationOrder: RotationOrder = new RotationOrder(dayIndex, monthIndex, savedProperty);
                rotationOrder.products.push(product);
                rotationOrder.userId = this.userPicker;
                this.rotationOrders = [...this.rotationOrders, rotationOrder];
                this.removeRotationOrderFromRotationOrdersToRemove(rotationOrder);
                this.documentPicker = "";
            }
            this.showMultiSelectionRotationOrderUserInformation = this.checkForDuplicateRotationOrdersWithDifferentUser();
        })
    }

    /**
     * Determines if there are duplicate rotation orders in this.originalRotationOrdersCopy and this.rotationOrders (determined using the day, month and saved property id)
     * and checks if the duplicates have different user ids
     *
     * @return True if duplicates with different users exist else false
     */
    private checkForDuplicateRotationOrdersWithDifferentUser(): boolean {
        if (!this.multipleSelectionModal) {
            return false;
        }

        return this.originalRotationOrdersCopy.some(originalRotationOrder => {
            return this.rotationOrders.some(rotationOrder => {
                //Check if a rotation order already exists (determined using day, month and the saved property id)
                const isSameRotationOrder = originalRotationOrder.day === rotationOrder.day && originalRotationOrder.month === rotationOrder.month && originalRotationOrder.savedProperty.id === rotationOrder.savedProperty.id;
                const hasDifferentUser = originalRotationOrder.userId !== rotationOrder.userId
                return isSameRotationOrder && hasDifferentUser;
            })
        })
    }

    /**
     * Get a product with a specific short name
     *
     * @param docname short name of the product that should be gotten
     * @return The found product or null if no product with the given short name can be found
     */
    private getProductByShortname(docname: string): Product | null {
        for (let product of this.products) {
            if (product.nameShort === docname) {
                return product
            }
        }
        return null;
    }

    /**
     * Determines if the dropdowns when creating a rotation order all have valid values
     *
     * @return True if all dropdowns have valid values else false
     */
    public isRotationOrderInputValid(): boolean {
        return this.documentPicker.valueOf() !== '' && this.monthPicker.valueOf() !== '' && this.dayPicker.valueOf() !== '' && this.userPicker !== '';
    }

    /**
     * Determines if a specific product is already part of a rotation order for a specific date (day, month).
     * If Only one saved property is considered also only rotation orders with the specific saved property ids are considered
     *
     * @return true If a rotation order with the specific product and on the specific date already exists else false
     */
    public isRotationAlreadyOrdered(): boolean {
        const dayIndex = this.days.indexOf(this.dayPicker.valueOf()) + 1;
        const monthIndex = this.months.indexOf(this.monthPicker.valueOf()) + 1;
        const productShortName = this.documentPicker.valueOf();

        if (this.multipleSelectionModal) {
            return this.rotationOrders.some(
                    rotationOrder => rotationOrder.products.some(product => product.nameShort === productShortName) &&
                            rotationOrder.month === monthIndex && rotationOrder.day === dayIndex)
        } else {
            return this.rotationOrders.some(
                    rotationOrder => rotationOrder.products.some(product => product.nameShort === productShortName) &&
                            rotationOrder.month === monthIndex && rotationOrder.day === dayIndex && rotationOrder.savedProperty.id === this.selectedSavedPropertyForModal.id)
        }
    }

    /**
     * Removes a specific product from a single rotation order or from multiple rotation orders if multiple saved properties where selected.
     * If a rotation order does not has any products left after removing, the rotation order is also removed from the list of rotation orders (this.rotationOrders)
     *
     * @param rotationOrderIndex Index in this.rotationOrders for the rotation order that should be removed
     * @param productIndex Index in the rotation order products for the product that should be removed
     */
    public removeProductFromRotationOrder(rotationOrderIndex: number, productIndex: number): void {
        if (this.multipleSelectionModal) {
            const rotationOrderToRemove: RotationOrder = this.rotationOrders[rotationOrderIndex];
            const productToRemove: Product = rotationOrderToRemove.products[productIndex];

            const allRotationOrdersToRemove = this.rotationOrders.filter(rotationOrder => rotationOrder.day === rotationOrderToRemove.day && rotationOrder.month === rotationOrderToRemove.month)

            for (const rotationOrder of allRotationOrdersToRemove) {
                rotationOrder.products.splice(rotationOrder.products.findIndex(product => product.nameShort === productToRemove.nameShort), 1)
                if (rotationOrder.products.length === 0) {
                    this.rotationOrders = this.rotationOrders.filter(rotationOrder =>
                            rotationOrder.day !== rotationOrderToRemove.day ||
                            rotationOrder.month !== rotationOrderToRemove.month
                    );
                }
            }
        } else {
            const removedProduct = this.rotationOrders[rotationOrderIndex].products.splice(productIndex, 1);
            // Make sure the rotation order productDates are updated accordingly
            const productDateIndex = this.rotationOrders[rotationOrderIndex].productDates.findIndex(productDate => productDate.productShortName === removedProduct[0].nameShort);
            if(productDateIndex !== -1){
              this.rotationOrders[rotationOrderIndex].productDates.splice(productDateIndex, 1);
            }
            if (this.rotationOrders[rotationOrderIndex].products.length === 0) {
                const removedRotationOrder = this.rotationOrders.splice(rotationOrderIndex, 1);
                if(!this.multipleSelectionModal){
                    this.rotationOrdersToRemove.push(...removedRotationOrder);
                }
            }
        }
        this.showMultiSelectionRotationOrderUserInformation = this.checkForDuplicateRotationOrdersWithDifferentUser();
    }

    /**
     * Handles the update of a rotation when updating a user.
     * Also handles loading animation and error message display if needed
     */
    public handleRotationOrderUserUpdate(): void{
        if(!this.userPicker){
            this.showUpdateUserError = true;
            this.updatingRotationOrderUser = false;
            return;
        }

        this.updatingRotationOrderUser = true;
        this.showUpdateUserError = false;

        //If the rotation order was previously saved at any time update the user otherwise set the user directly
        if(this.editRotationOrder.id){
            this.updateRotationOrderUser();
        }
        else{
            this.editRotationOrder.userId = this.userPicker;
            this.updatingRotationOrderUser = false;
            this.showMultiSelectionRotationOrderUserInformation = this.checkForDuplicateRotationOrdersWithDifferentUser();
            this.closeEditUserForRotationOrderModal();
        }
        this.errorRotationOrderIndex = undefined;
    }

    /**
     * Updates the user of a rotation order via the api
     */
    private updateRotationOrderUser(): void {
        const rotationOrder: RotationOrder = new RotationOrder(null, null, null);
        rotationOrder.userId = this.userPicker;

        this.rotationOrderService.updateUserForRotationOrder(this.editRotationOrder.id, this.loginIdService.getCurrentHeaders(), rotationOrder)
                .subscribe((updatedRotationOrder: RotationOrder) => {
                    const existingRotationOrderIndex = this.rotationOrders.findIndex((rotationOrder) =>
                            rotationOrder.day === this.editRotationOrder.day && rotationOrder.month === this.editRotationOrder.month &&
                            rotationOrder.savedProperty.id === this.editRotationOrder.savedProperty.id && rotationOrder.userId === this.editRotationOrder.userId);
                    if(existingRotationOrderIndex !== -1){
                        this.rotationOrders[existingRotationOrderIndex] = updatedRotationOrder
                    }
                    this.updatingRotationOrderUser = false;
                    this.showMultiSelectionRotationOrderUserInformation = this.checkForDuplicateRotationOrdersWithDifferentUser();
                    this.closeEditUserForRotationOrderModal();
                });
    }

    /**
     * updates all rotation orders from this.rotationOrders.
     * If multiple saved properties where selected each rotation order for each save property has to be handled individually for:
     *  - adding products to already existing rotation orders for a specific date
     *  - not updating rotation orders for specific date and product if it already exists
     */
    public async updateRotationOrders(): Promise<void> {
        if (this.multipleSelectionModal) {
            let updatedRotationOrders: RotationOrder[] = [];
            const rotationOrdersToAdd = JSON.parse(JSON.stringify(this.rotationOrders))
            for (const savedProperty of this.selectedSavedProperties) {
                const rotationOrdersForSavedProperty = this.getRotationOrdersForSavedPropertyById(rotationOrdersToAdd, savedProperty.id);

                rotationOrdersForSavedProperty.forEach(rotationOrder => {
                    //Try to get an already existing rotation order for a specific date and rotation order
                    const originalRotationOrderForDate = this.findOriginalRotationOrder(rotationOrder, savedProperty.id);

                    if (originalRotationOrderForDate) {
                        if (originalRotationOrderForDate.userId === rotationOrder.userId) {
                            this.updateOriginalRotationOrderProducts(originalRotationOrderForDate, rotationOrder);
                        }
                    } else {
                        this.originalRotationOrdersCopy.push(rotationOrder);
                    }
                })

                let rotationOrdersToSave = this.getRotationOrdersForSavedPropertyById(this.originalRotationOrdersCopy, savedProperty.id);
                this.setActualOrderDayAndMonthForSavedProperty(rotationOrdersToSave);

                await this.rotationOrderService.saveRotationOrders(rotationOrdersToSave, savedProperty.id, this.loginIdService.getCurrentHeaders()).toPromise().then(rotationOrders => {
                    updatedRotationOrders.push(...rotationOrders);
                })
            }
            this.updateRotationOrdersAfterSave(updatedRotationOrders);
            this.selectedSavedProperties = [];
            this.closeRotationOrderModal();
        } else {
            const rotationOrdersForSavedProperty = this.getRotationOrdersForSavedPropertyById(this.rotationOrders, this.selectedSavedPropertyForModal.id);
            this.setActualOrderDayAndMonthForSavedProperty(rotationOrdersForSavedProperty);
            this.rotationOrderService.saveRotationOrders(rotationOrdersForSavedProperty, this.selectedSavedPropertyForModal.id, this.loginIdService.getCurrentHeaders()).subscribe(res => {
                this.updateRotationOrdersAfterSave(res);
                this.closeRotationOrderModal();
            });
        }
    }

    /**
     * Opens a confirm dialog if a rotation order product should be removed from a rotation order
     *
     * @param rotationOrderIndex Index in this.rotationOrders for the rotation order that should be removed
     * @param productIndex Index in the rotation order products for the product that should be removed
     */
    public openConfirmationDialog(rotationOrderIndex: number, productIndex: number): void {
        const rotationOrder = this.rotationOrders[rotationOrderIndex];
        const rotationOrderProductName = rotationOrder.products[productIndex].name_long;
        const rotationOrderDate = rotationOrder.day + '. ' + this.months[rotationOrder.month - 1]

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: 'auto',
            data: {
                title: 'Turnus löschen?',
                'content': `Sind Sie sicher, dass der Turnus für '${rotationOrderProductName}' am ${rotationOrderDate} entfernt werden soll?`
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.removeProductFromRotationOrder(rotationOrderIndex, productIndex);
            }
        });
    }

    /**
     * Calculates the percentage of how many saved properties out of all saved properties have at least one rotation order
     *
     * @return percantage of all saved properties with at least one rotation order out of all saved properties
     */
    public calculateRotationOrderProgress(): number {
        if (this.rotationOrders && this.platformProfile) {
            const distinctSavedPropertyIds = new Set(
                    this.rotationOrders
                            .filter(rotationOrder => rotationOrder.savedProperty)
                            .filter(rotationOrder => this.platformProfile.properties.some(savedProperty => savedProperty.id === rotationOrder.savedProperty.id))
                            .map(rotationOrder => rotationOrder.savedProperty.id)
            );


            const numberOfDistinctPropertiesWithRotationOrder = distinctSavedPropertyIds.size;
            const numberOfSavedProperties = this.platformProfile.properties.length;

            if (numberOfSavedProperties > 0) {
                return numberOfDistinctPropertiesWithRotationOrder / numberOfSavedProperties * 100;
            } else {
                return 0;
            }
        }
    }

    /**
     * Gets the number of all rotation orders for a specific saved property
     *
     * @param savedProperty SavedProperty for which the number of rotation orders should be gotten
     */
    public getNumberOfRotationOrdersForSavedProperty(savedProperty: SavedProperty): number {
        if (this.rotationOrders && savedProperty) {
            return this.getRotationOrdersForSavedPropertyById(this.rotationOrders, savedProperty.id).length
        } else {
            return 0;
        }
    }

    /**
     * Gets the number of products for all rotation orders for a specific saved property
     *
     * @param savedProperty SavedProperty for which the number of all products of all rotation orders of that saved property should be gotten
     */
    public getNumberOfProductsFromRotationOrderForSavedProperty(savedProperty: SavedProperty): number {
        if (this.rotationOrders) {
            return this.getRotationOrdersForSavedPropertyById(this.rotationOrders, savedProperty.id).reduce((totalNumberOfProducts, rotationOrder) => {
                return totalNumberOfProducts + rotationOrder.products.length;
            }, 0)
        } else {
            return 0;
        }
    }

    /**
     * Gets the earliest date as string from all rotation orders of a specific saved property grouped by specific products by their short name
     *
     * @param productNames List of all product names for which only one date should be returned
     * @param savedProperty SavedProperty for which the rotation orders should be considered
     * @return custom date string of the format dd.MM or '--' if there is no rotation order for the saved property containing a product with a short name from productNames
     */
    public getDateStringForRotationOrderForSpecificProduct(productNames: string[], savedProperty: SavedProperty): string {
        const rotationOrdersForProducts: RotationOrder[] = [];
        for (let productName of productNames) {
            rotationOrdersForProducts.push(...this.getRotationOrdersForSpecificProductFromSavedProperty(productName, savedProperty));
        }
        if (rotationOrdersForProducts && rotationOrdersForProducts.length > 0) {
            let earliestRotationOrder: RotationOrder | null = rotationOrdersForProducts[0];

            for (const rotationOrder of rotationOrdersForProducts) {
                if (this.generateRotationOrderDate(rotationOrder) < this.generateRotationOrderDate(earliestRotationOrder)) {
                    earliestRotationOrder = rotationOrder
                }
            }

            return this.twoDigitNumberPipe.transform(earliestRotationOrder.day) + '.' + this.twoDigitNumberPipe.transform(earliestRotationOrder.month)
        }

        return '--'
    }

    /**
     * Gets all rotation orders which contain a specific product specified by its short name for a specific saved property
     *
     * @param productShortname Product short name that should be contained in the rotation order
     * @param savedProperty SavedProperty for which the rotation orders should be considered
     * @return Array of all rotation orders for a specific saved property that contain a specific product
     */
    public getRotationOrdersForSpecificProductFromSavedProperty(productShortname: string, savedProperty: SavedProperty): RotationOrder[] {
        const rotationOrdersForSavedProperty = this.getRotationOrdersForSavedPropertyById(this.rotationOrders, savedProperty.id)
        return rotationOrdersForSavedProperty.filter(rotationOrder => rotationOrder.products.some(product => product.nameShort === productShortname));
    }

    /**
     * Gets all rotation orders from an array of rotation orders for a saved property specified by its id
     *
     * @param rotationOrders Array of rotation orders which should be filtered
     * @param savedPropertyId SavedPropertyId for which the rotation orders should be found
     * @return Array of all rotation orders for a specific saved property
     */
    public getRotationOrdersForSavedPropertyById(rotationOrders: RotationOrder[], savedPropertyId: string): RotationOrder[] {
        return rotationOrders.filter(rotationOrder => rotationOrder.savedProperty.id === savedPropertyId);
    }

    /**
     * Generate a real date from a rotation order day and month
     *
     * @param rotationOrder RotationOrder for which the date should be generated
     * @return Generated date
     */
    public generateRotationOrderDate(rotationOrder: RotationOrder): Date {
        return new Date(new Date().getFullYear(), rotationOrder.month - 1, rotationOrder.day);
    }

    /**
     * Removes all rotation orders from this.rotationOrders which have an id of null
     */
    public removeRotationOrdersWithoutId(): void {
        this.rotationOrders = this.rotationOrders.filter(rotationOrder => rotationOrder.id)
    }

    /**
     * Determines if a specific saved property is selected when wanting to change multiple saved properties at once
     *
     * @param savedProperty SavedProperty which should be checked if it is selected or not
     * @return true if the specific saved property is selected else false
     */
    public isSavedPropertySelected(savedProperty: SavedProperty): boolean {
        return this.selectedSavedProperties.some(selectedSavedProperty => selectedSavedProperty.id === savedProperty.id)
    }

    /**
     * Determines if all saved properties are selected when wanting to change multiple saved properties at once
     *
     * @return true if all saved properties are selected else false
     */
    public areAllSavedPropertiesSelected(): boolean {
        if(!this.platformProfile){
            return false;
        }
        const hasPlatformProfileProperties = this.platformProfile.properties.length > 0;
        const areSelectedPropertiesInPlatformProperties = this.selectedSavedProperties.some(savedProperty => this.platformProfile.properties.some(platformProperty => savedProperty.id === platformProperty.id))
        return hasPlatformProfileProperties && this.selectedSavedProperties.length === this.platformProfile.properties.length && areSelectedPropertiesInPlatformProperties;
    }

    /**
     * Selects a saved property when wanting to change multiple saved properties at once.
     * When a saved property is already selected it gets unselected.
     *
     * @param savedProperty SavedProperty that should be selected
     */
    public selectSavedProperty(savedProperty: SavedProperty): void {
        if (this.isSavedPropertySelected(savedProperty)) {
            this.selectedSavedProperties.splice(this.selectedSavedProperties.findIndex(selectedSavedProperty => selectedSavedProperty.id === savedProperty.id), 1);
        } else {
            this.selectedSavedProperties.push(savedProperty);
        }
    }

    /**
     * Selects all saved properties when wanting to change multiple saved properties at once.
     */
    public selectAllSavedProperties(): void {
        if (this.platformProfile) {
            if (!this.areAllSavedPropertiesSelected()) {
                this.selectedSavedProperties = []
                this.selectedSavedProperties.push(...this.platformProfile.properties);
            } else {
                this.selectedSavedProperties = []
            }
        }
    }

    /**
     * Tries to get the full username (firstname + lastname) of a user by its id
     *
     * @param userId Id of the user for which the full username should be gotten
     * @return the full username if the user can be found in this.usersForPlatform else a empty string
     */
    public getFullUserNameById(userId: string): string{
        const foundUser = this.usersForPlatform.find(user => user.id === userId);
        if(foundUser){
            return foundUser.firstname + " " + foundUser.lastname
        }
        return "";
    }

    /**
     * Finds an original rotation for a given rotation order and a savedPropertyId in this.originalRotationOrdersCopy
     *
     * @param rotationOrder Rotation order to match the original rotation order
     * @param savedPropertyId Id of the saved property associated with the rotation order
     * @return The found original rotation order or undefined if nothing is found
     */
    private findOriginalRotationOrder(rotationOrder: RotationOrder, savedPropertyId: string): RotationOrder | undefined{
        return this.originalRotationOrdersCopy.find(originalRotationOrder =>
                originalRotationOrder.day === rotationOrder.day &&
                originalRotationOrder.month === rotationOrder.month &&
                originalRotationOrder.savedProperty.id === savedPropertyId
        )
    }

    /**
     * Updates the products in an original rotation order to match those in a new rotation order
     *
     * @param originalRotationOrder Original rotation order that should be updated
     * @param rotationOrder Rotation order containing the updated products
     */
    private updateOriginalRotationOrderProducts(originalRotationOrder: RotationOrder, rotationOrder: RotationOrder): void{
        //Helper sets to determine new products for an already existing rotation order
        const originalProducts: Set<string> = new Set(originalRotationOrder.products.map(product => product.nameShort))
        const newRotationOrderProducts: Set<string> = new Set(rotationOrder.products.map(product => product.nameShort))

        //All products that are not in the original rotation order but should be included
        const productsShortNamesNotInOriginalRotationOrder: string[] = Array.from(newRotationOrderProducts).filter(product => !originalProducts.has(product));

        //Add all products that should be included but are not to the original rotation order
        for (const productShortName of productsShortNamesNotInOriginalRotationOrder) {
            const product: Product | null = this.getProductByShortname(productShortName);
            if (product) {
                originalRotationOrder.products.push(product);
            }
        }
    }

    /**
     * Updates this.rotationOrders by removing all "old" rotation orders that where not saved yet and adding the saved rotation orders
     *
     * @param updatedRotationOrders All updated rotation order to be added.
     */
    private updateRotationOrdersAfterSave(updatedRotationOrders: RotationOrder[]): void {
        this.rotationOrders = JSON.parse(JSON.stringify(this.originalRotationOrdersCopy));
        for (const updatedRotationOrder of updatedRotationOrders) {
            const existingRotationOrderForDate = this.rotationOrders.find((rotationOrder) =>
                    rotationOrder.day === updatedRotationOrder.day&& rotationOrder.month === updatedRotationOrder.month && rotationOrder.savedProperty.id === updatedRotationOrder.savedProperty.id);

            if(existingRotationOrderForDate){
                this.rotationOrders.splice(this.rotationOrders.indexOf(existingRotationOrderForDate),1)
            }
        }
        this.rotationOrders = [...this.rotationOrders, ...updatedRotationOrders];
        this.removeDeletedRotationOrders();
        this.originalRotationOrdersCopy = JSON.parse(JSON.stringify(this.rotationOrders))
    }

    /**
     * Creates a new RotationOrderProductDate Object containing the actual date to order a specific product and adds it to the rotation order.
     *
     * @param rotationOrders Array of rotation orders for which the actual order dates should be calculated
     */
    private setActualOrderDayAndMonthForSavedProperty(rotationOrders: RotationOrder[]): void {
        for (const rotationOrder of rotationOrders) {
            const dateFromRotationOrder = this.generateRotationOrderDate(rotationOrder);

            for (const product of rotationOrder.products) {
                const orderDateForProductAlreadyExist = rotationOrder.productDates.some(productDate => productDate.productShortName === product.nameShort)
                if (orderDateForProductAlreadyExist) {
                    continue
                }

                const daysToSubtract = this.getDaysToSubtractForRotationOrderProduct(product.nameShort, rotationOrder.savedProperty);

                const dateForSpecificProduct = new Date(dateFromRotationOrder.getTime());
                dateForSpecificProduct.setDate(dateFromRotationOrder.getDate() - daysToSubtract);

                const dayForSpecificProduct = dateForSpecificProduct.getDate();
                const monthForSpecificProduct = dateForSpecificProduct.getMonth() + 1;

                const rotationOrderProductDates = new RotationOrderProductDate(dayForSpecificProduct, monthForSpecificProduct, product.nameShort);

                rotationOrder.productDates.push(rotationOrderProductDates);
            }
        }
    }

    /**
     * Calculates the number of days that have to be subtracted from a rotation order for the actual order date
     *
     * @param productShortName Short name of the product for which the days to subtract should be calculated
     * @param savedProperty SavedProperty - used to acquire the town and zip for the rotation order
     * @return Number of days to subtract for a specific product and Saved property.
     */
    private getDaysToSubtractForRotationOrderProduct(productShortName: string, savedProperty: SavedProperty): number {
        switch (productShortName) {
            case "grunde":
                if (savedProperty.town.trim().toLowerCase() === "berlin" || this.zipsInBerlin.includes(savedProperty.zip.trim())) {
                    return 21;
                }
                return 1;
            case "eliegen":
                return 1;
            case "liegen":
                return 14;
            default:
                return 0;
        }
    }

    /**
     * Remove all rotation orders from this.rotationOrders that where previously already deleted via the api
     */
    private removeDeletedRotationOrders(): void{
        this.rotationOrders = this.rotationOrders.filter(rotationOrder => !this.rotationOrdersToRemove.some(removeOrder =>
                rotationOrder.day === removeOrder.day &&
                rotationOrder.month === removeOrder.month &&
                rotationOrder.savedProperty?.id === removeOrder.savedProperty?.id
        ));
    }

    /**
     * Removes a specific rotation order from this.rotationOrdersToRemove
     *
     * @param rotationOrder Rotation order that should be removed from this.rotationOrdersToRemove
     */
    private removeRotationOrderFromRotationOrdersToRemove(rotationOrder: RotationOrder): void{
        const index = this.rotationOrdersToRemove.findIndex(order =>
                order.day === rotationOrder.day &&
                order.month === rotationOrder.month &&
                order.savedProperty?.id === rotationOrder.savedProperty?.id
        );

        if (index !== -1) {
            this.rotationOrdersToRemove.splice(index, 1);
        }
    }
}
